import { list } from '../../../../../common/classes/request-builder';
import {
    InputType,
    DropdownData,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { CalendarioTareaModel } from '../../../../../models/tareas/calendario-tarea.model';

type EventType = {
    name: string;
    value: string;
};

export class CalendarioTareasFormDefinition {
    public formFields!: Form<CalendarioTareaModel>;
    public readonly tiposEvento: DropdownData<EventType> = list<EventType>(
        ['Boda', { name: 'Boda', value: 'boda' }],
        ['Empresa', { name: 'Empresa', value: 'empresa' }],
        ['Degustación', { name: 'Degustación', value: 'degustacion' }],
    );

    constructor(
        public readonly formType: FormType,
        public readonly model: Partial<CalendarioTareaModel> = {},
    ) {
        this.formFields = {
            name: 'calendario-tareas',
            header: this.formType === FormType.EDITION ? 'Editar evento' : 'Crear evento',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<CalendarioTareaModel>[] {
        return [
            {
                name: '',
                fields: this.getMainFields(),
                width: 12,
                isVisible: true,
                order: 1,
            },
        ];
    }

    private getMainFields(): FormField<CalendarioTareaModel>[] {
        return [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: 'ID',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: true,
                },
                width: 12,
                conditions: this.conditions({ isVisible: false }),
                order: 1,
            },
            {
                name: 'title',
                vinculatedFields: undefined,
                label: 'Nombre del evento',
                input: {
                    type: InputType.TEXT,
                    isEditable: true,
                },
                width: 6,
                conditions: this.conditions({ isRequired: true }),
                order: 2,
            },
            {
                name: 'start',
                vinculatedFields: undefined,
                label: 'Fecha',
                input: {
                    type: InputType.CALENDAR,
                    isEditable: true,
                    calendarConfiguration: {
                        calendarView: 'date',
                        calendarDateFormat: 'dd-mm-yy',
                    },
                },
                width: 6,
                conditions: this.conditions({ isRequired: true }),
                order: 3,
            },
            {
                name: 'hora_inicio',
                vinculatedFields: undefined,
                label: 'Hora inicio',
                input: {
                    type: InputType.TIME,
                    isEditable: true,
                },
                width: 6,
                conditions: this.conditions(),
                order: 4,
            },
            {
                name: 'hora_fin',
                vinculatedFields: undefined,
                label: 'Hora fin',
                input: {
                    type: InputType.TIME,
                    isEditable: true,
                },
                width: 6,
                conditions: this.conditions(),
                order: 5,
            },
            {
                name: 'tipo_evento',
                vinculatedFields: undefined,
                label: 'Tipo de evento',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.tiposEvento,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'value',
                    },
                },
                width: 6,
                conditions: this.conditions(),
                order: 6,
            },
        ];
    }

    private conditions(values: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...values,
        };
    }
}
